import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../utils/api.js";
import Toastify from "../../utils/Toastify.js"


const initialState = {
    isRefresh: false,
    isLoading: false,
    notificationData: [],
    notificationCountData: 0,
    createdNotificationData:{},
    errorMsg: "",
    isError: false,
};

export const getNotification = createAsyncThunk('getNotification', async ({body,showAll}, { rejectWithValue, dispatch }) => {
    try {              
         
        const { data, status } = await api.getNotification(body,showAll);
         


        return data.data || []

    } catch (err) {
        console.log(err,"error");
        
        return rejectWithValue(err.response?.data?.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const getNotificationCount = createAsyncThunk('getNotificationCount', async (body, { rejectWithValue, dispatch }) => {
    try {
        const { data, status } = await api.getNotificationCount(body);
        if (status === 200) {
            dispatch(setNotificationCount(data.data))
            // dispatch(setRefresh())
        }
        return data.data

    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "'Something went wrong. Please try again later.'")
    }
}
)

export const markAsRead=createAsyncThunk('markAsRead',async(body, { rejectWithValue, dispatch })=>{
    try {
        const { data, status } = await api.markAsRead(body);
        if (status === 200) {
            dispatch(updateNotificationStatus(body))

        }
        return data.data

    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "'Something went wrong. Please try again later.'")
    }
})


export const markAllAsRead=createAsyncThunk('markAllAsRead',async(body,{rejectWithValue,dispatch})=>{
    try {
        
        const { data, status } = await api.markAllAsReaded(body);
         if(status === 200){
            dispatch (updateAllNotificationMarkAsRead())
            Toastify.success("Marked all notifications as readed  ✅ ");

            
         }

         return data.data

    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "'Something went wrong. Please try again later.'")

    }
})


// Opening the notifications page counts as seeing everything: clear the badge
// and mark them read on the server, without a toast
export const markAllSeen = createAsyncThunk('markAllSeen', async (userId, { rejectWithValue, dispatch }) => {
    try {
        dispatch(setNotificationCount(0))
        const { data } = await api.markAllAsReaded(userId);
        return data.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || "'Something went wrong. Please try again later.'")
    }
})


export const notificationSlice = createSlice({
    name: "notification",
    initialState,
    reducers: {
        setNotification: (state, action) => {
            if (Array.isArray(action.payload)) {
                state.notificationData = action.payload;
            }
        },
        setCreatednotification:(state,action)=>{
             state.createdNotificationData=action.payload
        },
        setNotificationCount: (state, action) => {
            state.notificationCountData = typeof action.payload === 'number' ? action.payload : 0
        },
        setRefresh:(state) => {
            state.isRefresh = !state.isRefresh
        },
        addNotification: (state, action) => {
            const notification = action.payload;
            if (!notification || typeof notification !== 'object') return;
            if (notification._id && state.notificationData?.some(n => n?._id === notification._id)) return;
            state.notificationData = [notification, ...(state.notificationData || [])]; // Prepend the new notification
        },
        updateNotificationStatus:(state,action)=>{
            const wasUnread = state.notificationData?.some(n => n?._id === action.payload && !n.isRead);
            state.notificationData = state.notificationData?.map((notification) => {
                if(action.payload === notification._id) {
                    return {
                        ...notification,
                        isRead: true
                    }
                } else {
                    return notification
                }
            });

            if (wasUnread && state.notificationCountData > 0) {
                state.notificationCountData -= 1;
              }
        },
        updateAllNotificationMarkAsRead:(state,action)=>{
            state.notificationData=state.notificationData?.map((notification)=>{
              return{
                ...notification,isRead:true
            }  
            })
            state.notificationCountData = 0
        }

    },

    extraReducers: (builder) => {

        
        builder.addCase(getNotification.pending, (state) => {
            state.isLoading = true
            state.isError = false
        })
        builder.addCase(getNotification.fulfilled, (state, action) => {
            state.isLoading = false
            state.notificationData = Array.isArray(action.payload) ? action.payload : []
        })
        builder.addCase(getNotification.rejected, (state, action) => {
            state.isLoading = false
            state.errorMsg = action.payload
        })
        
    }
})


export const { setNotification,setNotificationCount,setRefresh,addNotification, updateNotificationStatus , updateAllNotificationMarkAsRead,setCreatednotification} = notificationSlice.actions

export default notificationSlice.reducer;
